import { theme } from './theme';
import { css } from '@emotion/react';

export const LinkStyle = () => css`
	color: ${theme.color.primary['400']};

	:hover {
		color: ${theme.color.primary['400']};
		text-decoration: underline;
	}
`;
